import { Link } from 'react-router-dom';
import { categories, getCategoryBySlug } from '@/mocks/categories';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  categorySlug?: string;
}

export default function Breadcrumbs({ items, categorySlug }: BreadcrumbsProps) {
  const categoryName = categorySlug ? getCategoryBySlug(categorySlug)?.name : undefined;

  const schemaItems = items.map((item, index) => ({
    '@type': 'ListItem' as const,
    position: index + 1,
    name: item.label,
    item: item.to ? `https://jtdaifa.cn${item.to}` : undefined,
  }));

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: schemaItems,
  };

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
      <nav aria-label="Breadcrumb" className="py-3">
        <ol className="flex items-center flex-wrap gap-1 text-sm">
          {items.map((item, index) => (
            <li key={index} className="flex items-center gap-1">
              {index > 0 && (
                <i className="ri-arrow-right-s-line text-foreground-400 text-xs" />
              )}
              {item.to ? (
                <Link
                  to={item.to}
                  className="text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground-800 font-medium whitespace-nowrap">
                  {item.label}
                </span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}